import { render, staticRenderFns } from "./ApplicationStructureComponent.vue?vue&type=template&id=c4f8e020&scoped=true"
import script from "./ApplicationStructureComponent.vue?vue&type=script&lang=js"
export * from "./ApplicationStructureComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f8e020",
  null
  
)

export default component.exports